import { io } from "socket.io-client";
import { accessToken } from "./utils/localData";
const URL = process.env.REACT_APP_BASE_URL;
export const socket = io(URL, { auth: { token: accessToken() } });